export default function time(rawTime) {
    const date = new Date(`${rawTime}+0300`);
    const options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    };

    return new Intl.DateTimeFormat('ru-ru', options).format(date);
}
